<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1" id="pre">Key to Symbols</h1>
<table>
<tr>
<td valign="top"><img alt="fourstar" src="OEBPS/images/4star.jpg" style="width:20%"/></td>
<td valign="top">A great film<br/><br/></td>
</tr>
<tr>
<td valign="top"> </td>
<td valign="top"><span class="small">G, PG, PG-13, R, NC-17</span>: Ratings of the Motion Picture Association of America<br/><br/></td>
</tr>
<tr>
<td valign="top"><span class="small">G</span></td>
<td valign="top">Indicates that the movie is suitable for general audiences<br/><br/></td>
</tr>
<tr>
<td valign="top"><span class="small">PG</span></td>
<td valign="top">Suitable for general audiences but parental guidance is suggested<br/><br/></td>
</tr>
<tr>
<td valign="top"><span class="small">PG-13</span></td>
<td valign="top">Recommended for viewers 13 years or above; may contain material inappropriate for younger children<br/><br/></td>
</tr>
<tr>
<td valign="top"><span class="small">R</span></td>
<td valign="top">Recommended for viewers 17 or older<br/><br/></td>
</tr>
<tr>
<td valign="top"><span class="small">NC-17</span></td>
<td valign="top">Intended for adults only<br/><br/></td>
</tr>
<tr>
<td valign="top">141 m.</td>
<td valign="top">Running time<br/><br/></td>
</tr>
<tr>
<td valign="top">2011</td>
<td valign="top">Year of theatrical release</td>
</tr>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792175_epub_pre_r1.vue?703153e6